import styled from 'styled-components'

export const Container = styled.div`
  width: 22vw;
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    margin: 0 8px;
  }
`
